'use client'

import { Button, Container, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { SELLING_HELP_URL } from '../../constants/routes'

type Props = {
  show: boolean
  onClose: () => void
}

const DelayedPublicationModal = ({ show, onClose }: Props) => {
  const translate = useTranslate('delayed_publication.modal')

  const renderTitle = () => (
    <Text as="h1" text={translate('title')} alignment="left" type="heading" />
  )

  const renderBody = () => (
    <Text
      as="span"
      text={translate('body', {
        'catalog-rules-link': chunks => (
          <a href={SELLING_HELP_URL} target="_blank" rel="noopener noreferrer">
            {chunks}
          </a>
        ),
      })}
      html
    />
  )

  const renderActions = () => (
    <Button
      text={translate('actions.close')}
      onClick={onClose}
      styling="filled"
      testId="delayed-publication-modal-close-button"
    />
  )

  return (
    <Dialog show={show} testId="delayed-publication-modal">
      <Container>
        {renderTitle()}
        <Spacer size="large" />
        {renderBody()}
        <Spacer size="large" />
        {renderActions()}
      </Container>
    </Dialog>
  )
}

export default DelayedPublicationModal
